import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DeliveryPeriodReferenceService extends BaseReferenceService {
  constructor() {
    super('DeliveryPeriodReference');
  }
}
